const ChinaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111173)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M10.9453 12.1719L12.6719 17.4844H18.2578L13.7422 20.7734L15.4688 26.0859L10.9453 22.8047L6.42188 26.0859L8.15625 20.7734L3.63281 17.4844H9.21875L10.9453 12.1719Z"
        fill="#FFDA44"
      />
      <path
        d="M23.7114 30.9775L22.3911 29.3525L20.438 30.1104L21.5708 28.3525L20.2505 26.7197L22.2739 27.2588L23.4146 25.501L23.5239 27.5947L25.5552 28.1338L23.5942 28.8838L23.7114 30.9775Z"
        fill="#FFDA44"
      />
      <path
        d="M26.3364 26.2119L26.9614 24.2119L25.2505 23.001L27.3442 22.9697L27.9614 20.9697L28.6411 22.9541L30.7349 22.9307L29.0552 24.1807L29.727 26.165L28.0161 24.9541L26.3364 26.2119Z"
        fill="#FFDA44"
      />
      <path
        d="M29.8745 14.6797L28.9526 16.5625L30.4526 18.0234L28.3823 17.7266L27.4605 19.6016L27.1011 17.5391L25.0229 17.2422L26.8823 16.2656L26.523 14.1953L28.023 15.6562L29.8745 14.6797Z"
        fill="#FFDA44"
      />
      <path
        d="M23.7656 8.97754L23.6094 11.0635L25.5547 11.8525L23.5156 12.3525L23.3672 14.4463L22.2656 12.665L20.2266 13.165L21.5781 11.5635L20.4688 9.79004L22.4141 10.5791L23.7656 8.97754Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111173">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ChinaSvg;
